export default (state) => {
  let foundedItems = state.bookeroNews.filter(news => !news.readed);
  return foundedItems.length;
};



// WEBPACK FOOTER //
// ./src/store/getters/global/unreadedNewsCount.js